import { Component, Input, OnInit } from '@angular/core';
import { VoidFlag } from 'src/app/core/enums/VoidFlag';
import { OrderD } from 'src/app/core/models/OrderD';
import { OrderModifier } from 'src/app/core/models/OrderModifier';
import { OrderSourceFlag } from 'src/app/core/enums/OrderSourceFlag';

@Component({
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss']
})
export class OrderItemComponent implements OnInit {
  @Input() item: OrderD;
  @Input() currCode: string;
  @Input() isOrderSummaryPage: boolean;
  @Input() linkId: number;
  @Input() isShowSlashPrice: boolean;
  @Input() orderType?: string;

  voidFlag = VoidFlag;
  thumbnail: string = "";
  OrderSourceFlag: OrderSourceFlag;
  displayOrderSourceFlag: boolean = false;
  modifierSourceFlag: string;
  modifierIcon: string;

  constructor(
  ) { }

  ngOnInit(): void {

    let thumbnailStatus = this.item.orderDAttrs.find(val => val.attrCode == 'ITEMIMGURL');
    if (thumbnailStatus) {
      this.thumbnail = thumbnailStatus.attrValue;
    }

    if (this.orderType && this.orderType != null && this.orderType != undefined) {
      const orderSourceFlag = this.orderType as OrderSourceFlag;

      const pickupTypes: OrderSourceFlag[] = [OrderSourceFlag.WebPickup, OrderSourceFlag.WebQrTakeaway];
      const dineInTypes: OrderSourceFlag[] = [OrderSourceFlag.WebDineIn, OrderSourceFlag.WebQrDineIn];

      const isOrderTypePickup = pickupTypes.includes(orderSourceFlag);
      const isOrderTypeDineIn = dineInTypes.includes(orderSourceFlag);

      if (!isOrderTypePickup && (this.item.sourceFlag === OrderSourceFlag.WebQrTakeaway || this.item.sourceFlag === OrderSourceFlag.WebPickup)) {
        this.displayOrderSourceFlag = true;
        this.modifierIcon = "oda-bag";
        this.modifierSourceFlag = 'qr.merchant.order.type.1';
      }

      if (!isOrderTypeDineIn && (this.item.sourceFlag === OrderSourceFlag.WebQrDineIn || this.item.sourceFlag === OrderSourceFlag.WebDineIn)) {
        this.displayOrderSourceFlag = true;
        this.modifierIcon = "oda-qr-dinein";
        this.modifierSourceFlag = 'order.info.dine.in';
      }
    }
  }

  checkHasSubModifiers(modifiers: OrderModifier) {
    if (modifiers.subModifiers) {
      return true;
    }
    else {
      return false;
    }
  }

}
